module.exports = __webpack_public_path__ + "img/1970East-079_WEB-min.6bc59c4c.jpg";